import script from "./Addition.vue?vue&type=script&setup=true&lang=js"
export * from "./Addition.vue?vue&type=script&setup=true&lang=js"

import "./Addition.vue?vue&type=style&index=0&id=3c2c1fe5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c2c1fe5"]])

export default __exports__